
//Libraries
import { defineComponent, onMounted, ref } from "vue";

//Types
import type { FeaturedUserType } from "../../shared/types/featured-user-type";

export default defineComponent({
  name: "GameRounds",
  setup() {
    //Data

    const isLoading = ref<boolean>(true);

    const users = ref<FeaturedUserType[]>([]);

    //Methods

    const getData = async (): Promise<boolean> => {
      return true;
    };

    //Lifecycle Hooks

    onMounted(() => {
      getData().then(() => {
        users.value = [
          {
            id: "a",
            name: "Inteligencia artificial",
            points: 150,
            place: "Por Didier Balam",
          },
          {
            id: "a",
            name: "Torneo de verano",
            points: 150,
            place: "Por Jehieli Tamayo",
          },
          {
            id: "a",
            name: "Tecnologías 2021",
            points: 150,
            place: "Motul - Yucatán",
          },
          {
            id: "a",
            name: "Exámen Tecnológico",
            points: 150,
            place: "Motul - Yucatán",
          },
          {
            id: "a",
            name: "Día del ingeniero",
            points: 150,
            place: "Motul - Yucatán",
          },
        ];
        setTimeout(() => {
          isLoading.value = false;
        }, 1000);
      });
    });

    return {
      //Data
      isLoading,
      users,
    };
  },
});
